import { render, staticRenderFns } from "./SPExtendTimeItem.vue?vue&type=template&id=6a72848d&scoped=true&"
import script from "./SPExtendTimeItem.vue?vue&type=script&lang=js&"
export * from "./SPExtendTimeItem.vue?vue&type=script&lang=js&"
import style0 from "./SPExtendTimeItem.vue?vue&type=style&index=0&id=6a72848d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a72848d",
  null
  
)

export default component.exports